import React from 'react';
import { Link } from 'react-router-dom';
import { FiLinkedin } from 'react-icons/fi'; // Import minimal LinkedIn icon
import './Footer.css';

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-logo">
        <Link to="/">
          <img
            src="https://dzsyhtfpcz9op.cloudfront.net/staticResources/logo_intoreality.tv.png"
            alt="Footer Logo"
          />
        </Link>
      </div>

      {/* Social Icons Section with Minimalistic LinkedIn Logo */}
      <div className="footer-social-icons">
        <a
          href="https://www.linkedin.com/company/into-reality-sl/"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-icon"
        >
          <FiLinkedin />
        </a>
      </div>

      <div className="footer-copyright">
        <hr />
        <p>Copyright © 2025 - All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
